import { Badge } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { NameResponsive } from './NameToIconResponsive';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface IBadgedTabPaneProps {
  showBadge: boolean;
  icon: React.ReactNode;
  name: string;
}

/**
 * Wrapper del titolo di un tab con badge per indicare la presenza di nuovi elementi/notifiche
 */
export function TabContentWithBadge(props: IBadgedTabPaneProps) {
  const { showBadge, icon, name } = props;
  return (
    <StyledDiv>
      <NameResponsive name={name} icon={icon} />
      {showBadge && <Badge dot color={'blue'} />}
    </StyledDiv>
  );
}
